/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Notification_Bell_Label_OneInputs */



/**
* | output |
* | --- |
* | "{count} new notification" |
*
* @param {Notification_Bell_Label_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const notification_bell_label_one = /** @type {((inputs: Notification_Bell_Label_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Bell_Label_OneInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} neue Benachrichtigung`)
	return /** @type {LocalizedString} */ (`${i?.count} new notification`)
});